import { render, staticRenderFns } from "./CurrentAccountPreAccActionsView.vue?vue&type=template&id=796f76e0&scoped=true&"
import script from "./CurrentAccountPreAccActionsView.vue?vue&type=script&lang=ts&"
export * from "./CurrentAccountPreAccActionsView.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentAccountPreAccActionsView.vue?vue&type=style&index=0&id=796f76e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f76e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer,VTooltip})
